let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("idiEK")).then(() => parcelRequire('268HQ'));